import { WithTMSConnectionId } from 'api/types/pathParams';
import ApiUrlParams from 'constants/apiUrlParams';

import { API_REQ_ACTION_TYPES } from '../actions';
import apiReqSagaCreator from '../apiReqSagaCreator';
import { ApiPaths, HTTP_METHODS } from '../constants';

export type ConnectionType =
  | 'tmw'
  | 'truckmate'
  | 'innovative'
  | 'truckmate_rest'
  | 'tmt_maintenance'
  | 'truckmate_master_data'
  | 'truckmate_finance';

export interface TmsConnectionDetails extends BaseEntity, WithHypermedia {
  valid: boolean;
  type: ConnectionType;
  username: string;
  baseUrl: string;
  authUrl?: string;
  password?: string;
}

type ReusedConnectionDetailsProps =
  'baseUrl' | 'username' | 'password' | 'authUrl' | 'type';

export type ValidateTmsCredentials = Pick<
  TmsConnectionDetails,
  ReusedConnectionDetailsProps
>;

interface ParamsToTest {
  [paramName: string]: string;
}

export type GetTmsConnectionsResult = DataWithTotal<TmsConnectionDetails>;
export type AddTmsConnectionParams = ValidateTmsCredentials;
type GetTmsConnectionDetailsParams = WithTMSConnectionId;
type GetTmsConnectionDetailsResult = TmsConnectionDetails;
type ValidateTmsCredentialsParams = ValidateTmsCredentials;

export interface TestEndpointParams extends GetEndpointsParams {
  params: ParamsToTest;
  tms_id: string;
}

export interface TmsEndpointResponse {
  keys: KeyValuePairs<{
    type: 'text' | 'number';
    value: string | number;
  }>;
}

export interface ValidateTmsCredentialsResult {
  valid: boolean;
}

export interface GetEndpointsParams {
  type: string;
}

export interface EndpointContent {
  endpoint: string;
  params: string[];
}

export interface GetEndpointsResult {
  endpoints: KeyValuePairs<EndpointContent>;
}

const TmsConnections = {
  // TODO: remove once old form goes
  getConnectionDetails: apiReqSagaCreator<
    GetTmsConnectionDetailsParams,
    GetTmsConnectionDetailsResult
  >(API_REQ_ACTION_TYPES.TMS_CONNECTIONS.GET_CONNECTION_DETAILS, (params) => ({
    method: HTTP_METHODS.GET,
    url: ApiPaths.tmsConnections.byId._({
      [ApiUrlParams.tmsConnectionId]: params[ApiUrlParams.tmsConnectionId],
    }),
  })),
  validateCredentials: apiReqSagaCreator<
    ValidateTmsCredentialsParams,
    ValidateTmsCredentialsResult
  >(API_REQ_ACTION_TYPES.TMS_CONNECTIONS.VALIDATE_CREDENTIALS, (data) => ({
    method: HTTP_METHODS.POST,
    url: ApiPaths.tmsConnections.validateCredentials._(),
    data,
  })),
  getEndpoints: apiReqSagaCreator<GetEndpointsParams, GetEndpointsResult>(
    API_REQ_ACTION_TYPES.TMS_CONNECTIONS.GET_ENDPOINTS,
    (params) => ({
      method: HTTP_METHODS.GET,
      url: ApiPaths.tmsConnections.endpoints._(),
      params,
    })
  ),
  testEndpointParams: apiReqSagaCreator<
    TestEndpointParams,
    TmsEndpointResponse
  >(API_REQ_ACTION_TYPES.TMS_CONNECTIONS.TEST_ENDPOINT_PARAMS, (data) => ({
    method: HTTP_METHODS.POST,
    url: ApiPaths.tmsConnections.endpoints.keys._(),
    data,
    transformRequest: (d) => JSON.stringify(d),
  })),
};

export default TmsConnections;
